var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Block } from '../Block';
import { BlockSectionContent, StyledBlockSection } from './BlockSection.Styles';
import { BlockSectionControls } from './BlockSectionControls';
import { usePage, usePageEdit } from '../../../ModulePage';
import { useBlockSection } from '../';
export var BlockSectionList = memo(function (_a) {
    var _b;
    var id = _a.id;
    var page = usePage().page;
    var _c = useBlockSection(), isColumn = _c.isColumn, blockSectionId = _c.blockSectionId;
    var pageInEditMode = usePageEdit().pageInEditMode;
    if (((_b = page.data.blocks[blockSectionId]) === null || _b === void 0 ? void 0 : _b.length) === 0 && !pageInEditMode)
        return null;
    return (React.createElement(StyledBlockSection, { id: id, editMode: pageInEditMode },
        React.createElement(Droppable, { droppableId: blockSectionId, type: "box", key: blockSectionId, direction: isColumn ? 'vertical' : 'horizontal' }, function (provided, snapshot) { return (React.createElement(BlockSectionContent, __assign({ ref: provided.innerRef, style: {
                background: snapshot.isDraggingOver ? 'rgba(255, 230, 224, 0.5)' : 'transparent'
            } }, provided.droppableProps),
            React.createElement(BlockSectionControls, null),
            page.data.blocks[blockSectionId].map(function (blockId, index) {
                return React.createElement(Block, { key: index + "-" + blockId, id: blockId, index: index });
            }),
            provided.placeholder)); })));
});
